module.exports = __webpack_public_path__ + "img/logo-russian-applicant.56cfb55d.svg";